import styled from 'styled-components';
import { Button } from '@salutejs/sdds-insol';
import { useModalStore } from '@/entities/Modal';
import { Typography } from '@/shared/ui/Typography';
import Logo from '@/shared/assets/lk/lkLogo.svg?react';
import { ModalWrapper } from '@/shared/ui/ModalWrapper';
import cls from './GoalUpdatedModal.module.scss';

const StyledButton = styled(Button)`
    background-color: #333f48;
`;

export const GoalUpdatedModal = () => {
    const { isGoalUpdatedModalOpen, setIsGoalUpdatedModalOpen } = useModalStore();

    return (
        <ModalWrapper id="goalUpdatedModal" isOpened={isGoalUpdatedModalOpen} setIsOpened={setIsGoalUpdatedModalOpen}>
            <div className={cls.container}>
                <Logo className={cls.logo} />
                <Typography className={cls.title} as="h5" variant="h5_bold">
                    Цель успешно изменена
                </Typography>
                <StyledButton
                    className={cls.button}
                    size="xl"
                    view="dark"
                    type="submit"
                    stretch
                    onClick={() => {
                        setIsGoalUpdatedModalOpen(false);
                    }}
                >
                    <span className="SBSansText">Понятно</span>
                </StyledButton>
            </div>
        </ModalWrapper>
    );
};
